import { useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { IrregularProduct } from 'scenes/Producer/Product/MyProducts/constants';

function useIrregularProductVariations(parentId: number, options?: UseQueryOptions<IrregularProduct[]>) {
  return useQuery<IrregularProduct[]>(
    ['product', parentId, 'irregular-variations'],
    () => productService.getIrregularProductVariations(parentId),
    options
  );
}

export { useIrregularProductVariations };
